import React from 'react';

import Grid from '@material-ui/core/Grid';

import UavosConfig from './Uavos';
import ZonesConfig from './Zones';

const DashboardConfiguration = () => (
  <Grid container style={{ padding: 20 }}>
    <Grid item xs={12}>
      <ZonesConfig />
    </Grid>
    <Grid item xs={12}>
      <UavosConfig />
    </Grid>
  </Grid>
);

export default DashboardConfiguration;
